const style = [
    {
        selector: "node",
        style: {
            "shape": "rectangle",
            "font-family": "Libre Franklin,sans-serif",
            "font-weight": "bold",
        },
    },
    {
        selector: "node[type = 'root']",
        css: {
            "label": "data(name)",
            "text-wrap": "wrap",
            "color": "#333333",
            "background-color": "#e0e1dd",
            "font-size": "23px",
            "padding": "15",
            "border-width": "2",
            "border-color": "#666666",
            "width": "350px",
            "height": "label",
            "text-max-width": "310px",
            "text-halign": "center",
            "text-valign": "center",
            "line-height": "1.5",
        },
    },
    {
        selector: "node[type = 'node']",
        style: {
            "label": "data(name)",
            "color": "#333333",
            "background-color": "#CDD7D9",
            "border-width": "2",
            "border-color": "#666666",
            "font-size": "18px",
            "width": "275px",
            "height": "label",
            "text-wrap": "wrap",
            "text-halign": "center",
            "text-valign": "center",
            "padding": "10",
        },
    },
    {
        selector: "node[type = 'leaf']",
        style: {
            "label": "data(name)",
            "font-size": "14px",
            "background-color": "white",
            "shape": "rectangle",
            "width": "250px",
            "text-halign": "center",
            "text-valign": "center",
            "color": "#333333",
            "text-wrap": "wrap",
            "text-max-width": "250px",
            "border-width": "2",
            "border-color": "#666666",
            "padding": "10",
            "line-height": "1.4",
        },
    },
    {
        selector: "node[type = 'title']",
        css: {
            "label": "data(name)",
            "text-wrap": "wrap",
            "color": "#333333",
            "background-color": "#ffffff",
            "width": "label",
            "height": "label",
            "font-size": "24px",
            "text-halign": "center",
            "text-valign": "center",
            "padding": "20",
        },
    },
    {
        selector: "node[type = 'legend_neutral']",
        css: {
            "label": "Neutral eingestellt",
            "text-wrap": "wrap",
            "color": "#000000",
            "background-color": "#ffffff",
            "width": "150px",
            "height": "25px",
            "font-size": "10px",
            "text-halign": "center",
            "text-valign": "center",
            "padding": "7",
            "border-width": "1",
            "border-color": "#000000",
        },
    },
    {
        selector: "node[type = 'legend_positive']",
        css: {
            "label": "Positiv eingestellt",
            "text-wrap": "wrap",
            "color": "#000000",
            "background-color": "#ACB9A4",
            "width": "150px",
            "height": "25px",
            "font-size": "10px",
            "text-halign": "center",
            "text-valign": "center",
            "padding": "7",
            "border-width": "1",
            "border-color": "#000000",
        },
    },
    {
        selector: "node[type = 'legend_negative']",
        css: {
            "label": "Negativ eingestellt",
            "text-wrap": "wrap",
            "color": "#000000",
            "background-color": "#D3AFA5",
            "width": "150px",
            "height": "25px",
            "font-size": "10px",
            "text-halign": "center",
            "text-valign": "center",
            "padding": "7",
            "border-width": "1",
            "border-color": "#000000",
        },
    },
    {
        selector: "node[type = 'legend_winner']",
        css: {
            "background-image": "/img/winner.svg",
            "background-clip": "none",
            "bounds-expansion": "0 0 0 0",
            "background-width": "26",
            "background-height": "26",
            "background-repeat": "no-repeat",
            "background-position-x": "1",
            "background-position-y": "1",
            "label": "Gewinnerthema",
            "text-wrap": "wrap",
            "color": "#000000",
            "background-color": "#ffffff",
            "width": "150px",
            "height": "25px",
            "font-size": "10px",
            "text-halign": "center",
            "text-valign": "center",
            "padding": "7",
            "border-width": "1",
            "border-color": "#000000",
        },
    },
    {
        selector: "node[type = 'legend_active']",
        css: {
            "label": "Aktiv",
            "text-wrap": "wrap",
            "color": "#000000",
            "background-color": "#ffffff",
            "width": "150px",
            "height": "25px",
            "font-size": "10px",
            "text-halign": "center",
            "text-valign": "center",
            "padding": "7",
            "border-width": "1",
            "border-color": "#000000",
        },
    },
    {
        selector: "node[type = 'legend_passive']",
        css: {
            "label": "Passiv",
            "text-wrap": "wrap",
            "color": "#999999",
            "background-color": "#ffffff",
            "width": "150px",
            "height": "25px",
            "font-size": "10px",
            "text-halign": "center",
            "text-valign": "center",
            "padding": "7",
            "border-width": "1",
            "border-color": "#999999",
        },
    },
    {
        selector: "node[type = 'node'][bias > 0]",
        style: {
            "background-image": "/img/positiv.svg",
            "background-clip": "none",
            "bounds-expansion": "18 0 0 0",
            "background-width": "20",
            "background-height": "20",
            "background-repeat": "no-repeat",
            "background-position-x": "1",
            "background-position-y": "1",
        },
    },
    {
        selector: "node[type = 'node'][bias < 0]",
        style: {
            "background-image": "/img/negativ.svg",
            "background-clip": "none",
            "bounds-expansion": "18 0 0 0",
            "background-width": "20",
            "background-height": "20",
            "background-repeat": "no-repeat",
            "background-position-x": "1",
            "background-position-y": "1",
        },
    },
    {
        selector: "node[type = 'leaf'][bias < 0]",
        style: {
            "background-color": "#D3AFA5",
            "background-opacity": "0.5",
            "border-color": "#D3AFA5",
            "text-border-color": "#D3AFA5",
            "text-border-opacity": "0",
        },
    },
    {
        selector: "node[type = 'leaf'][bias > 0]",
        style: {
            "background-color": "#ACB9A4",
            "text-border-color": "#ACB9A4",
            "text-border-opacity": "0",
            "background-opacity": "0.5",
            "border-color": "#ACB9A4",
        },
    },
    {
        selector: "node[type = 'leaf'][attitude < 0]",
        style: {
            "background-color": "#D3AFA5",
            "background-opacity": "0.5",
            "border-color": "#D3AFA5",
            "text-border-color": "#D3AFA5",
            "text-border-opacity": "0",
        },
    },
    {
        selector: "node[type = 'leaf'][attitude > 0]",
        style: {
            "background-color": "#ACB9A4",
            "text-border-color": "#ACB9A4",
            "text-border-opacity": "0",
            "background-opacity": "0.5",
            "border-color": "#ACB9A4",
        },
    },
    {
        selector: "node[type = 'leaf'][isWinner > 0]",
        style: {
            "background-image": "/img/winner.svg",
            "background-clip": "none",
            "bounds-expansion": "0 0 0 0",
            "background-width": "26",
            "background-height": "26",
            "background-repeat": "no-repeat",
            "background-position-x": "1",
            "background-position-y": "1",
        },
    },
    {
        selector: "node[type = 'leaf'][isActive = 0]",
        style: {
            "color": "#999999",
            "border-color": "#999999",
        },
    },
    {
        selector: ".delete",
        css: {
            "background-image": "/img/delete-1.svg",
            "background-clip": "none",
            "background-width": "18",
            "background-height": "18",
            "background-repeat": "no-repeat",
            "bounds-expansion": "0 50 0 0 ",
            "background-position-x": "242",
            "background-position-y": "1",
        },
    },
    {
        selector: ".deleteNode",
        css: {
            "background-image": "/img/delete-1.svg",
            "background-clip": "none",
            "background-width": "18",
            "background-height": "18",
            "background-repeat": "no-repeat",
            "background-position-x": "100%",
            "background-position-y": "0%",
        },
    },
    {
        selector: "edge",
        style: {
            width: "0",
        },
    },
    {
        selector: "edge.taxi",
        style: {
            "width": "2",
            "curve-style": "taxi",
            "taxi-direction": "auto",
            "source-arrow-shape": "tee",
            "arrow-scale": "1",
        },
    },
    {
        selector: "node[type = 'group']",
        style: {
            "font-size": "12px",
            "background-opacity": "0",
            "padding": "0",
            "background-color": "#fff",
            "border-width": "0",
            "min-height-bias-top": "0%",
        },
    },
]

export default style
